import { Box } from '@ff-it/ui';
import Big from 'big.js';
import type { ExpenseRow } from 'modules/invoicing/expenses/types';
import { oddRow } from 'styles/style.css';
import { fmt } from 'utilities';
import { amountColumn, numberCell, popoverText, popoverTextBold, popoverTitle, tableCell } from './style.css';

interface ExpenseRowsPopoverProps {
  rows: ExpenseRow[];
}

/**
 * This shows in a popover a list of expense rows (title and amount) that were grouped under the same imported block
 * code.
 */
export function ExpenseRowsPopover({ rows }: ExpenseRowsPopoverProps) {
  return (
    <Box p="1">
      <div className={popoverTitle}>Invoice rows</div>
      <table>
        <colgroup>
          <col />
          <col className={amountColumn} />
        </colgroup>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? undefined : oddRow}>
              <td className={tableCell}>
                <div className={popoverText}>{row.title}</div>
              </td>
              <td className={numberCell}>
                <div className={popoverTextBold}>{fmt(Big(row.total))}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
}
